import { useState } from 'react';
import TicketCreateForm from '../TicketCreateForm';
import { TicketFormModel } from '../../models/ticket.model';
import { useProject } from '../../context/ProjectContext';
import moment from 'moment-timezone';


export default function TicketCreate(props: any) {
  const { setBlockScreen } = props
  const { selectedProject } = useProject()
  const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  const [ticketForm, setTicketForm] = useState<TicketFormModel>({
    number: '',
    created_by: {},
    created_date: '',
    title: '',
    priority: '',
    status_0: '',
    status_n: '',
    failure_date: moment().tz(userTimezone).format(),
    description: '',
    element: '',
    company: '',
    area: '',
    technician: '',
    attachment: {},
    alarms: [],
    custom_fields: {},
    notification_profile: {id: '', label: ''},
    project_code: selectedProject
  })

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
    setTicketForm(ticketForm => ({
      ...ticketForm,
      [event.target.name]: event.target.value
    }));
  }
  
  const handleSelection = (key: string, value: string): void => {
    setTicketForm(ticketForm => ({
      ...ticketForm,
      [key]: value
    }));
  }
  
  const handleCheck = (event: React.ChangeEvent<HTMLInputElement>): void => {
    setTicketForm(ticketForm => ({
      ...ticketForm,
      [event.target.name]: event.target.checked ? 'true' : 'false'
    }));
  };

  const handleCustomFieldChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
    setTicketForm(prevForm => ({
      ...prevForm,
      custom_fields: {
        ...prevForm.custom_fields,
        [event.target.name]: {
        ...prevForm.custom_fields[event.target.name], 
        value: event.target.value,
        }
      }
    }));
  };

  return (
    <TicketCreateForm
      setBlockScreen={setBlockScreen}
      action='create'
      ticketForm={ticketForm}
      handleChange={handleChange}
      handleSelection={handleSelection}
      handleCheck={handleCheck}
      handleCustomFieldChange={handleCustomFieldChange}
    />)
}